import CancellablePromise from '@/types/cancellable-promise';
import ComparisonItem from '@/types/comparison-item';
import Nullable from '@/types/nullable';
import Portfolio from '@/types/portfolio';
import PortfolioHolding from '@/types/portfolio-holding';
import { PortfolioEditorContext } from '@/utils/portfolios';

export type PortfolioCalculationPromiseReturn = {
  newPortfolio: Portfolio;
  comparisonItem: ComparisonItem;
};

export enum PortfolioBuilderContentOption {
  QuickSearch = 'quickSearch',
  FundScreener = 'fundScreener',
  ProxyScreener = 'proxyScreener',
  RiskProfile = 'riskProfile',
  ComplianceAlternatives = 'complianceAlternatives',
}

export type EditPortfolioState = {
  calculationPromise?: Nullable<CancellablePromise<PortfolioCalculationPromiseReturn>>;
  portfolio: Portfolio;
  comparisonItem?: ComparisonItem;
  holdingToReplace?: PortfolioHolding;
  isSaving: boolean;
  isDirty: boolean;
  isLoading: boolean;
  contentOption: PortfolioBuilderContentOption;
  holdingToCompareComplianceAlts?: PortfolioHolding;
  isCalculating: boolean;
  onCancel: () => void;
  canSave?: boolean;
  productAdded?: PortfolioHolding;
  editorContext?: PortfolioEditorContext;
  isPortfolioValueLocked?: boolean;
  showTaxDetails?: boolean;
  isCreatingModel?: boolean;
};
